var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 18.439 3.69-2.828c1.961 2.56 4.044 3.739 6.363 3.739 2.307 0 4.33-1.166 6.203-3.704l3.744 2.759c-2.702 3.66-6.059 5.595-9.947 5.595-3.875 0-7.265-1.922-10.053-5.561zm10.04-12.289-6.568 5.66-3.036-3.52 9.619-8.29 9.543 8.296-3.05 3.509z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickup);
export default __webpack_public_path__ + "static/media/clickup.1a43389c71ff0d4ea1e7e06a054c303b.svg";
export { ForwardRef as ReactComponent };